const defaultHandlers = require('./default-handlers');

module.exports = require('./create-client');
module.exports.createModuleWithDefaults = require('./create-module-with-defaults');
module.exports.get = defaultHandlers.get;
module.exports.set = defaultHandlers.set;
module.exports.call = defaultHandlers.call;
module.exports.utils = require('./utils');
